import React, {useState} from "react";
import HelperService from "../services/helper-service";
import {useEventService} from "../services/event-service";
import {useGlobalNotificationMessage} from "../context/message";

export default function ClassReview( {eventId, onSuccess, ...props} ){
    const [ratingFormData, setRatingFormData] = useState({review: '', text: ''});
    const [submitting, setSubmitting] = useState(false);

    const es = useEventService();
    const {addErrorMessage} = useGlobalNotificationMessage();

    const handleRatingSubmit = event => {
        event.preventDefault();
        setSubmitting(true);
        es.createReview(eventId, ratingFormData)
            .then(async (res) => {
                if ('function'===typeof onSuccess){
                    onSuccess(res);
                    setSubmitting(false);
                }
            })
            .catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage);
                setSubmitting(false);
            });
    };

    const ClickableStarRating = ({rating, onChange, starClass="text-warning", ...props}) => {
        const stars = HelperService.round(rating, 0.5);
        function starClick(val){
            if (val === rating){
                val = null;
            }
            if ('function'===typeof onChange){
                onChange(val);
            }
        }
        return (<div>
            <div>
                {[...Array(5)]
                    .map((item, i) =>
                        <button
                            type="button"
                            key={'star-' + i}
                            onClick={(e)=>starClick(i+1)}
                            className={`fs-5 border-0 bg-white mdi mdi-star ${stars>i ? starClass : 'text-secondary'} `}>
                        </button>)}
            </div>
        </div>);
    }

  return (
      <>
          {eventId && <form onSubmit={handleRatingSubmit}>
              <div className="form-group my-3">
                  <ClickableStarRating rating={ratingFormData.review} onChange={(val) => setRatingFormData({...ratingFormData, 'review': val})}/>
              </div>
              <div className="form-group my-3">
                  <textarea className="form-control" rows="3" placeholder="Write your review (optional)" name="text" value={ratingFormData.text}
                            onChange={(event) => setRatingFormData({...ratingFormData, 'text': event.target.value})}/>
              </div>
              <div className="form-group my-3">
                 <button className="btn btn-primary" type="submit" disabled={!ratingFormData.review || submitting}>Submit review</button>
              </div>
          </form>}
      </>
  );
}
